import { FormField, Textarea } from '@vwfs-bronson/bronson-react';
import { useField } from 'formik';
import React, { MouseEventHandler } from 'react';

import { InfoIcon } from '../../info-icon';
import { getInputErrorMessageComponentAndId, hasError } from '../errors';

export type ValidatedTextareaProps = {
    name: string;
    maxLength?: number;
    id?: string;
    placeholder?: string;
    testId?: string;
    tooltip?: string;
    onLinkClick?: MouseEventHandler;
    label: string;
    ariaLabel?: string;
    isMandatory?: boolean;
    enableMaxLength?: boolean;
    onFocus?: () => void;
    disabled?: boolean;
    hint?: string;
    className?: string;
    required?: boolean;
    requiredText?: string;
};

export const ValidatedTextarea: React.FC<ValidatedTextareaProps & React.HTMLAttributes<HTMLTextAreaElement>> = ({
    id,
    testId,
    name,
    tooltip,
    onLinkClick,
    label,
    ariaLabel,
    maxLength,
    placeholder,
    isMandatory = false,
    enableMaxLength = false,
    disabled,
    hint,
    className,
    required,
    requiredText,
}) => {
    const [field, meta] = useField({ name, type: 'textarea' });
    const infoIcon = tooltip ? <InfoIcon text={tooltip} /> : null;

    const { errorMessageComponent, errorMessageId } = getInputErrorMessageComponentAndId({
        name,
        id,
        meta,
        testId,
    });

    return (
        <FormField
            labelForId={id}
            type="textarea"
            onClick={onLinkClick}
            labelText={label}
            testId={`${testId}FormField`}
            id={id}
            errorMessage={errorMessageComponent}
            infoIcon={infoIcon}
            required={isMandatory}
            hint={hint}
            className={className}
            requiredText={isMandatory ? requiredText : undefined}
        >
            <Textarea
                error={!disabled && hasError(meta)}
                aria-describedby={errorMessageId}
                aria-label={ariaLabel || label}
                id={id}
                testId={testId}
                placeholder={placeholder}
                charCounter
                maxCounter={maxLength}
                enableMaxLength={enableMaxLength}
                disabled={disabled}
                required={required}
                {...field}
            />
        </FormField>
    );
};
